/* [PATCH likvidacija-fe v1] Nastavitve -> Podjetje -> stikalo "Likvidacija racunov".
   Lastni API GET/PUT /dokumenti/{cid}/likvidacija/modul (company_modules, module='likvidacija';
   odsotnost vrstice = IZKLOPLJENO, [PATCH likvidacija-fe v6] privzetek obrnjen). Shranjuje se sproti, neodvisno od gumba Shrani. */
import React, { useEffect, useState } from 'react';
import { ClipboardCheck } from 'lucide-react';
import { api } from '../../lib/api';

export function LikvidacijaKartica({ companyId }: { companyId: string }) {
  const [vklop, setVklop] = useState(false); // [PATCH likvidacija-fe v6] privzeto izklopljeno
  const [busy, setBusy] = useState(false);
  const [spor, setSpor] = useState('');

  useEffect(() => {
    if (!companyId) return;
    setSpor('');
    api.get(`/dokumenti/${companyId}/likvidacija/modul`)
      .then(r => setVklop(r.data?.likvidacija === true))
      .catch(() => {});
  }, [companyId]);

  const shrani = async (novo: boolean) => {
    setBusy(true); setSpor('');
    try {
      const r = await api.put(`/dokumenti/${companyId}/likvidacija/modul`, { likvidacija: novo });
      setVklop(r.data?.likvidacija === true);
      setSpor(r.data?.likvidacija ? 'Likvidacija vklopljena.' : 'Likvidacija izklopljena — potrjevanje in plačila delujejo brez likvidacije.');
    } catch (e: any) { setSpor(e?.response?.data?.detail || 'Shranjevanje ni uspelo.'); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 flex items-center justify-center">
          <ClipboardCheck className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Likvidacija računov</h2>
          <p className="text-xs text-gray-500">Stranka z likvidacijo sporoči računovodstvu, da je prejeti račun v redu. Dokler račun ni likvidiran, ga računovodja ne more potrditi in stranka ne more plačati (SEPA, oznaka »plačano«). Po likvidaciji je račun za stranko zaklenjen; za urejanje likvidacijo prekliče. Pravico »Lahko likvidira« dodelite uporabnikom stranke v zavihku Uporabniki.</p>
        </div>
      </div>
      <div className="mt-4 flex items-start gap-3">
        <button type="button" disabled={busy} onClick={() => shrani(!vklop)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition disabled:opacity-50 ${vklop ? 'bg-emerald-600' : 'bg-gray-300 dark:bg-gray-600'}`}>
          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${vklop ? 'translate-x-6' : 'translate-x-1'}`} />
        </button>
        <div className="flex-1">
          <div className="text-sm font-medium text-gray-900 dark:text-white">{vklop ? 'Likvidacija računov je vklopljena' : 'Likvidacija računov je izklopljena'}</div>
          <div className="text-xs text-gray-500 mt-1">{vklop ? 'Potrditev in plačilo zahtevata likvidacijo stranke.' : 'Privzeto izklopljeno — vse deluje kot pred uvedbo likvidacije.'}</div>
          {spor && <div className="text-xs text-emerald-700 dark:text-emerald-300 mt-1">{spor}</div>}
        </div>
      </div>
    </div>
  );
}
